module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cont",
    class: _vm.creative !== null ? 'blurred' : ''
  }, [_c('header', {
    staticClass: "header"
  }, [_c('nav-bar', [_c('div', {
    staticClass: "nav-item",
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('a', {
    attrs: {
      "href": "https://www.adikteev.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": "MotionLead logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-item",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('h2', {
    staticClass: "subtitle contact",
    on: {
      "click": function($event) {
        _vm.showContact = true
      }
    }
  }, [_vm._v("Contact Us")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('div', {
    attrs: {
      "id": "filters"
    }
  }), _vm._v(" "), (_vm.hasFilters) ? _c('div', {
    staticClass: "delete-filters",
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n        Delete filters\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "item-list"
  }, _vm._l((_vm.filteredCreatives), function(creative, index) {
    return _c('item', {
      key: creative.key,
      attrs: {
        "item": creative,
        "delay": index * 50
      },
      on: {
        "delete": _vm.deleteItem
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('overlay'), _vm._v(" "), (_vm.showContact) ? _c('contact', {
    on: {
      "dismiss": function($event) {
        _vm.showContact = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8813ef14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemList.vue
// module id = 284
// module chunks = 1